const GMAPS_CALLBACK_NAME = 'gmapsCallback';

let promise = null;

export const gmapApiLoader = (googleApiKey) => {
    promise = promise || new Promise((resolve, reject) => {

        let timeout = setTimeout(function () {
            window[GMAPS_CALLBACK_NAME] = function () {};
            reject(new Error('Google maps could not be loaded. Please contact administrator.'));
        }, 10000);

        window[GMAPS_CALLBACK_NAME] = function () {
            if (timeout !== null) {
                clearTimeout(timeout);
            }
            resolve(window.google.maps);
            delete window[GMAPS_CALLBACK_NAME];
        };

        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        // Drawing is implemented in-house (helpers/shape-drawer.js) since Google removed the
        // `drawing` library in Maps JS v3.65, so no version pin is needed anymore.
        // places.Autocomplete is legacy-deprecated but still served to existing customers;
        // when Google announces its shutdown, migrate to PlaceAutocompleteElement.
        script.src = `https://maps.googleapis.com/maps/api/js?v=quarterly&loading=async&libraries=places&language=en-US&key=${googleApiKey}&callback=${GMAPS_CALLBACK_NAME}`;
        script.onerror = reject;

        document.body.appendChild(script);
    }).catch((err) => {
        // Don't cache a failed load forever — reset so a later call can retry.
        promise = null;
        throw err;
    });

    return promise;
};
